import type { SSOPrefillData } from "../types";
import {
  submitSsoConfigWizard,
  wizardSubmitErrorMessage,
} from "./vysorWizardSubmit";
import { getRequiredSsoFields } from "./getRequiredSsoFields";

export function ssoPrefillToCollected(
  prefill: SSOPrefillData,
): Record<string, string> {
  return {
    application_id: prefill.applicationId || "",
    application_name: prefill.applicationName || "",
    instance_id: prefill.instanceId || "",
    sso_type: prefill.sso_type || "SAML",
    platform_id: prefill.platform || "generic_saml",
    platform: prefill.platform || "generic_saml",
    metadata_or_notes:
      prefill.metadata_url || prefill.business_justification || "",
    metadata_url: prefill.metadata_url || "",
    metadata_entity_id: prefill.entity_id || "",
    metadata_acs_url: prefill.acs_url || "",
    oidc_discovery_endpoint: prefill.oidc_discovery_endpoint || "",
    redirect_uris: (prefill.redirect_uris || []).join("\n"),
    grant_type: prefill.grant_type || "",
    client_id: prefill.client_id || "",
  };
}

export function canSubmitSsoPrefill(prefill: SSOPrefillData): boolean {
  if (!prefill.applicationId?.trim() || !prefill.instanceId?.trim())
    return false;
  return getRequiredSsoFields({
    sso_type: prefill.sso_type || "SAML",
    grant_type: prefill.grant_type,
    entity_id: prefill.entity_id,
    acs_url: prefill.acs_url,
    metadata_url: prefill.metadata_url,
    redirect_uris: prefill.redirect_uris,
    oidc_discovery_endpoint: prefill.oidc_discovery_endpoint,
    client_id: prefill.client_id,
  }).ready;
}

export async function submitSsoFromAssistantPrefill(
  prefill: SSOPrefillData,
  contactEmail?: string,
): Promise<{ status?: string; connection_name?: string }> {
  if (!prefill.applicationId?.trim() || !prefill.instanceId?.trim()) {
    throw new Error(
      "Application and environment are required before submitting SSO.",
    );
  }
  if (!canSubmitSsoPrefill(prefill)) {
    const type = (prefill.sso_type || "SAML").toUpperCase();
    const reqs = getRequiredSsoFields({
      sso_type: prefill.sso_type,
      grant_type: prefill.grant_type,
      entity_id: prefill.entity_id,
      acs_url: prefill.acs_url,
      metadata_url: prefill.metadata_url,
      redirect_uris: prefill.redirect_uris,
      oidc_discovery_endpoint: prefill.oidc_discovery_endpoint,
      client_id: prefill.client_id,
    });
    throw new Error(
      type === "OIDC"
        ? `Add ${reqs.missingLabels.join(" and ") || "required OIDC fields"} before submitting.`
        : "Add the app Entity ID and ACS URL (or a SAML metadata URL) before submitting — otherwise the SSO review stays empty.",
    );
  }
  return submitSsoConfigWizard(ssoPrefillToCollected(prefill), contactEmail);
}

export function assistantPrefillSubmitError(err: unknown): string {
  return wizardSubmitErrorMessage(err, "Please try again.");
}
